// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23pcZ","inner":"Footer_inner__1v_-d"};